import { formatTime } from "../../../utils/timeConversion";
import { getVoyageNumber } from "../../../utils/domainSelectors";
import { getSelectedCargo, getSelectedTrip } from "../../../utils/voyageSelection";

export const createTankCertificatePrintViewModelV2 = ({
  currentVoyage,
  selectedTripId,
  selectedCargoIndex,
  selectedTanks,
  companyLogo,
  isCTC,
  is24Hour,
  t,
}) => {
  const selectedTrip = getSelectedTrip(currentVoyage, selectedTripId);
  const selectedCargo = getSelectedCargo(
    currentVoyage,
    selectedTripId,
    selectedCargoIndex
  );

  if (!selectedCargo) {
    throw new Error(t("forPrint.selectCargoBeforePrint"));
  }

  const inspectionActivity = selectedCargo?.activities?.["tank-inspection"];

  return {
    companyLogo: companyLogo || "",
    vesselName: currentVoyage?.vessel || "\u2014",
    title: isCTC ? t("forPrint.ctcTitle") : t("forPrint.etcTitle"),
    voyageNumber: getVoyageNumber(currentVoyage) || "\u2014",
    portName: selectedTrip?.to || "\u2014",
    jettyName: selectedTrip?.jetty || "",
    inspectionDate: inspectionActivity?.date || "\u2014",
    inspectionTime: inspectionActivity?.time
      ? formatTime(inspectionActivity.time, is24Hour)
      : "\u2014",
    cargoName: selectedCargo?.cargo || "\u2014",
    statement: isCTC
      ? t("forPrint.beforeLoadingText")
      : t("forPrint.afterDischargeText"),
    selectedTanks: String(selectedTanks || "")
      .split(",")
      .map((tank) => tank.trim())
      .filter(Boolean),
    chiefOfficer: selectedTrip?.crew?.chiefOfficer || "\u2014",
  };
};
